import audio1 from "../assets/solutions/audioVideoSystems/1.jpg";
import audio2 from "../assets/solutions/audioVideoSystems/2.jpg";
import audio3 from "../assets/solutions/audioVideoSystems/3.jpg";
import audio4 from "../assets/solutions/audioVideoSystems/4.jpg";
import audio5 from "../assets/solutions/audioVideoSystems/5.jpg";
import audio6 from "../assets/solutions/audioVideoSystems/6.jpg";
import audio7 from "../assets/solutions/audioVideoSystems/7.jpg";
import audio8 from "../assets/solutions/audioVideoSystems/8.jpg";

import publicEva1 from "../assets/solutions/publicAddressVoiceEvacuationSystems/1.jpeg";
import publicEva2 from "../assets/solutions/publicAddressVoiceEvacuationSystems/2.jpg";
import publicEva3 from "../assets/solutions/publicAddressVoiceEvacuationSystems/3.png";

import fireDet1 from "../assets/solutions/fireDetectionAlarmSystem/1.jpeg";
import fireDet2 from "../assets/solutions/fireDetectionAlarmSystem/2.jpeg";
import fireDet3 from "../assets/solutions/fireDetectionAlarmSystem/3.jpg";
import fireDet4 from "../assets/solutions/fireDetectionAlarmSystem/4.jpg";

import security1 from "../assets/solutions/securitySystem/1.jpg";
import security2 from "../assets/solutions/securitySystem/2.jpg";
import security3 from "../assets/solutions/securitySystem/3.jpg";
import security4 from "../assets/solutions/securitySystem/4.jpg";

import smartHouse1 from "../assets/solutions/homeAutomationSmartHomes/1.jpg";
import smartHouse2 from "../assets/solutions/homeAutomationSmartHomes/2.jpg";
import smartHouse3 from "../assets/solutions/homeAutomationSmartHomes/3.jpg";
import smartHouse4 from "../assets/solutions/homeAutomationSmartHomes/4.jpg";

import entrance1 from "../assets/solutions/automaticEntranceSolutions/1.jpg";
import entrance2 from "../assets/solutions/automaticEntranceSolutions/2.jpg";
import entrance3 from "../assets/solutions/automaticEntranceSolutions/3.jpg";
import entrance4 from "../assets/solutions/automaticEntranceSolutions/4.jpg";
import entrance5 from "../assets/solutions/automaticEntranceSolutions/5.jpg";
import entrance6 from "../assets/solutions/automaticEntranceSolutions/6.jpg";
import entrance7 from "../assets/solutions/automaticEntranceSolutions/7.jpg";
import entrance8 from "../assets/solutions/automaticEntranceSolutions/8.jpg";

import ELV1 from "../assets/solutions/otherELVsolutions/1.jpeg";
import ELV2 from "../assets/solutions/otherELVsolutions/2.jpg";
import ELV3 from "../assets/solutions/otherELVsolutions/3.jpg";
import ELV4 from "../assets/solutions/otherELVsolutions/4.jpg";

const audioVideo = {
  id: 1,
  name: "Audio Video Systems",
  paragraph:
    "AV systems are truly all around us, helping to entertain, inform and enlighten us every day! \nAV systems explain different systems can be integrated and control together.",
  listTitle: "The most common types of AV systems include:",
  list: [
    "Video Conference System.",
    "Audio Conference system.",
    "Interpretation system.",
    "Projectors and Projection Screens.",
    "Screens & Video Wall System.",
    "Home and Cinema Sound Systems.",
    "Digital Signage System.",
    "AV Control System",
    "Audio / Video Intercom",
  ],
  pictures: [
    {
      id: 1,
      name: "audio1",
      image: audio1,
    },
    {
      id: 2,
      name: "audio2",
      image: audio2,
    },
    {
      id: 3,
      name: "audio3",
      image: audio3,
    },
    {
      id: 4,
      name: "audio4",
      image: audio4,
    },
    {
      id: 5,
      name: "audio5",
      image: audio5,
    },
    {
      id: 6,
      name: "audio6",
      image: audio6,
    },
    {
      id: 7,
      name: "audio7",
      image: audio7,
    },
    {
      id: 8,
      name: "audio8",
      image: audio8,
    },
  ],
};

const publicAddress = {
  id: 2,
  name: "Public Address & Voice Evacuation Systems",
  paragraph:
    "Public Address and Voice alarm evacuation systems allow safe and controlled building evacuation to be managed in the case of an emergency. \n Clear voice pre-recorded messages can be initiated from the system to aid building evacuation. The systems can also be used to provide background music and paging system solutions and  allow a person to communicate or relay to a large public, for example to announcements at large and noisy areas or amplify any other audio content, whether recorded or live.",
  listTitle: "The most components of the PA & Evac. Systems include:",
  list: ["Amplifiers.", "Loud speakers.", "Microphones."],
  pictures: [
    {
      id: 1,
      name: "publicEva1",
      image: publicEva1,
    },
    {
      id: 2,
      name: "publicEva2",
      image: publicEva2,
    },
    {
      id: 3,
      name: "publicEva3",
      image: publicEva3,
    },
  ],
};

const fireDetection = {
  id: 3,
  name: "Fire Detection Alarm System",
  paragraph:
    "A fire alarm system warns people when smoke, fire, carbon monoxide or other fire-related or general notification emergency / emergencies are detected. These alarms activated automatically through detectors or may also be activated via manual fire alarm activation devices such as manual call points. Alarms system includes sounders or horns. They can also be speaker strobes which sound an alarm, followed by a voice evacuation message which warns people inside the building not to use the elevators.",
  listTitle: "The most components of the Fire Detection Alarm System include:",
  list: [
    "Fire Alarm Control Panel.",
    "Smoke / Heat Detectors.",
    "Manual Call Points.",
    "Siren / Sounder.",
    "Control / Monitor Module.",
  ],
  pictures: [
    {
      id: 1,
      name: "fireDet1",
      image: fireDet1,
    },
    {
      id: 2,
      name: "fireDet2",
      image: fireDet2,
    },
    {
      id: 3,
      name: "fireDet3",
      image: fireDet3,
    },
    {
      id: 4,
      name: "fireDet4",
      image: fireDet4,
    },
  ],
};

const securitySystem = {
  id: 4,
  name: "Security System",
  paragraph:
    "The most basic definition of any security system is found in its name. It is literally a means or method by which something is secured through a system of interworking components and devices.\n Security alarms used in residential, commercial, industrial, and military properties protect against burglary (theft) or property damage, as well as personal protection against intruders. Security alerts in neighborhoods show a connection with diminished robbery.",
  listTitle: "The most common types of Security Systems include:",
  list: [
    "Video Surveillance System (CCTV).",
    "Intruder Alarm System.",
    "Access Control System.",
    "Fence Alarm System. ",
  ],
  pictures: [
    {
      id: 1,
      name: "security1",
      image: security1,
    },
    {
      id: 2,
      name: "security2",
      image: security2,
    },
    {
      id: 3,
      name: "security3",
      image: security3,
    },
    {
      id: 4,
      name: "security4",
      image: security4,
    },
  ],
};

const homeAutomation = {
  id: 5,
  name: "Home Automation & Smart Homes",
  paragraph:
    "A home automation system monitor and/or control home attributes such as lighting, climate, entertainment systems, and appliances. It may also include home security such as access control and alarm systems. When connected with the Internet, home devices are an important constituent of the Internet of Things. \n A home automation system typically connects controlled devices to a central smart home hub. The user interface for control of the system uses either wall-mounted terminals, tablet or desktop computers, a mobile phone application, or a Web interface that may also be accessible off-site through the Internet.",
  listTitle:
    "",
  list: [],
  pictures: [
    {
      id: 1,
      name: "smartHouse1",
      image: smartHouse1,
    },
    {
      id: 2,
      name: "smartHouse2",
      image: smartHouse2,
    },
    {
      id: 3,
      name: "smartHouse3",
      image: smartHouse3,
    },
    {
      id: 4,
      name: "smartHouse4",
      image: smartHouse4,
    },
  ],
};

const automaticEntrance = {
  id: 6,
  name: "Automatic Entrance Solutions",
  paragraph:
    "The most basic definition of any automatic entrance solutions is manual entrance equipped with a power-operated mechanism and controls that open and close the device automatically upon receipt of a momentary actuating signal.",
  listTitle: "The most common types of Automatic Entrance Solutions include:",
  list: [
    "Rising Pollards.",
    "Gate Barrier.",
    "Road Blocker.",
    "Turnstile.",
    "Tire Killer.",
    "Sliding Gate.",
    "Automatic Sliding / Swinging Doors.",
    "Speed PVC Doors.",
    "Shutter Gates.",
  ],
  pictures: [
    {
      id: 1,
      name: "entrance1",
      image: entrance1,
    },
    {
      id: 2,
      name: "entrance2",
      image: entrance2,
    },
    {
      id: 3,
      name: "entrance3",
      image: entrance3,
    },
    {
      id: 4,
      name: "entrance4",
      image: entrance4,
    },
    {
      id: 5,
      name: "entrance5",
      image: entrance5,
    },
    {
      id: 6,
      name: "entrance6",
      image: entrance6,
    },
    {
      id: 7,
      name: "entrance7",
      image: entrance7,
    },
    {
      id: 8,
      name: "entrance8",
      image: entrance8,
    },
  ],
};

const otherELV = {
  id: 7,
  name: "Other ELV Solutions",
  paragraph: "",
  listTitle:
    "Safe zone provide a several other ELV systems the most common of other ELV Solutions include:",
  list: [
    "Master Clock System.",
    "Tower Clock.",
    "Parking guidance and management system.",
    "Queuing management System.",
  ],
  pictures: [
    {
      id: 1,
      name: "ELV1",
      image: ELV1,
    },
    {
      id: 2,
      name: "ELV2",
      image: ELV2,
    },
    {
      id: 3,
      name: "ELV3",
      image: ELV3,
    },
    {
      id: 4,
      name: "ELV4",
      image: ELV4,
    },
  ],
};

export {
  audioVideo,
  publicAddress,
  fireDetection,
  securitySystem,
  homeAutomation,
  automaticEntrance,
  otherELV,
};
